<template>
  <div>
    <div class="row mt-20">
      <div class="container">
        <div class="col-md-12">
          <div id="warranty-bg" class="bg-pos"></div>
        </div>
      </div>
    </div>
    <div class="row mt-20">
      <div class="container">
        <div class="col-md-12">
          <div class="h2 bold text-center">
            {{ $t('warrantyPage.header') }}
          </div>
          <div v-html="$t('warrantyPage.textBlock')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Warranty',
}
</script>

<style></style>
